import { render, staticRenderFns } from "./OpenBuy.vue?vue&type=template&id=868e9e5e&"
import script from "./OpenBuy.vue?vue&type=script&lang=js&"
export * from "./OpenBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports